import { makeVar } from "@apollo/client";
import type { ItemListName, PageType } from "./type";
import { isBot } from "~/util/is-bot";

type InitialState = {
  isLoadingGA: boolean;
  fromItemNameForDetail: ItemListName | "related_videos" | "related_books";
  /**
   * id がある場合 : id を指定する
   * id がない場合 : null を指定する
   */
  detailItemListId: string | null;
  pageType: PageType | null;
  index: number | null;
  viaShowPosition: number;
  viaViewRank: number | null;
};

const initialState: InitialState = {
  isLoadingGA: !isBot(),
  fromItemNameForDetail: "list",
  detailItemListId: null,
  pageType: null,
  index: null,
  viaShowPosition: 1,
  viaViewRank: null,
};

export const isLoadingGAVar = makeVar(initialState.isLoadingGA);
export const pageTypeVar = makeVar(initialState.pageType);
